import { Tool } from "./interfaces";

export const libraries = [
  {
    type: "library",
    name: "Ant Design",
    level: "Experienced",
    image: "ant-design.svg",
    tags: ["Web", "VueJs", "Components"],
    experience: "+2 years",
    description: "",
  },
  {
    type: "library",
    name: "Tailwind CSS",
    level: "Experienced",
    image: "Tailwind_CSS_Logo.svg",
    tags: ["Web", "Tailwind CSS", "VueJs"],
    experience: "+1 years",
    description: "",
  },
  {
    type: "library",
    name: "Bulma CSS",
    level: "Intermediate",
    image: "bulma-seeklogo.com.svg",
    tags: ["Web", "Bulma CSS", "VueJs", "Components"],
    experience: "1 year",
    description: "",
  },
  {
    type: "library",
    name: "Element & Element Plus",
    level: "Experienced",
    image: "element-plus-logo.svg",
    tags: ["Web", "Components"],
    experience: "+2 years",
    description: "",
  },
  {
    type: "library",
    name: "Bootstrap",
    level: "Experienced",
    image: "bootstrap.svg",
    tags: ["Web", "Components"],
    experience: "+4 years",
    description: "",
  },
] as Array<Tool>;
